import { render, staticRenderFns } from "./InputLabel.vue?vue&type=template&id=415de0dd&"
import script from "./InputLabel.vue?vue&type=script&lang=ts&"
export * from "./InputLabel.vue?vue&type=script&lang=ts&"
import style0 from "./InputLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports